<template> </template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import { setActivityAndLogout, logOutRequired } from '../../lib/UserSession.js';
import { unauthenticatedRoutes, unauthenticatedRoutesEnforceTimeout } from '../../router';

export default {
  name: 'UserActivityTracker',
  data: function() {
    return {};
  },
  async beforeMount() {
    // Dont need to save the interaction when timedout already happen
    // This trap the refresh page where the component get mounted and reset the timer.
    // Use case: where user reopen the tab (OR refresh) when session has timedout >10 - if we update the activity then the session will still be valid.
    let loginOutRequired = await logOutRequired(this.$auth);
    if (typeof Storage !== 'undefined' && !loginOutRequired) {
      localStorage.setItem('lastActivityTime', JSON.stringify(Date.now()));
    }
    this.activateActivityTracker();
  },
  methods: {
    // Adding the event listerner to tracker user activity
    activateActivityTracker() {
      if (isExperienceEditorActive() || typeof window == 'undefined') {
        // if expereince editor - escape
        return;
      } else {
        window.addEventListener('scroll', this.setActivityAndLogout);
        window.addEventListener('keydown', this.setActivityAndLogout);
        window.addEventListener('resize', this.setActivityAndLogout);
        window.addEventListener('click', this.setActivityAndLogout);
        window.addEventListener('touch', this.setActivityAndLogout);
        // TODO - do we consider switching the tab from inactive to active as a user interaction?
        // window.addEventListener('focus', this.setActivityAndLogout);
      }
    },
    async setActivityAndLogout(event) {
      if (isExperienceEditorActive()) {
        // if expereince editor - escape
        return;
      }
      let sessionTeimdOut = await setActivityAndLogout();

      // Before proceeding to the logout we will need to check:
      //        if the user is already authenticated - no need to logout if the user is not even logged in...
      //        if the route is an unprotected route in which case there is no need to redirect - we can stay on the page
      let userAuthenticated = true;
      if (this.$auth !== null && typeof this.$auth != 'undefined') {
        let isAuthenticated = await this.$auth.isAuthenticated();
        if (!isAuthenticated) {
          userAuthenticated = false;
        }
      }
      // Check the route is unprotected
      let isProtectedRoute = true;
      if (
        (unauthenticatedRoutes.includes(this.$route.path) ||
          !(this.$route.meta.requiresAuth === true)) && // Unprotected page
        !unauthenticatedRoutesEnforceTimeout.includes(this.$route.path) // Exception page like /login which are unprotected but we need to enforce the logout on timeout
      ) {
        isProtectedRoute = false;
      }

      // try to automatically logout on next action - not just routing
      // This will handle any click on the page where not browing away or scroll....
      if (sessionTeimdOut && userAuthenticated && isProtectedRoute) {
        event.preventDefault();
        event.stopPropagation();
        this.$router.push('/logout');
      }
    },
  },
  // remove all the events used to track user activities
  beforeDestroy() {
    if (typeof window != 'undefined') {
      window.removeEventListener('scroll', this.setActivityAndLogout);
      window.removeEventListener('keydown', this.setActivityAndLogout);
      window.removeEventListener('resize', this.setActivityAndLogout);
      window.removeEventListener('click', this.setActivityAndLogout);
      window.removeEventListener('touch', this.setActivityAndLogout);
      // TODO - do we consider switching the tab from inactive to active as a user interaction?
      // window.removeEventListener('focus', this.setActivityAndLogout);
    }
  },
};
</script>

<style lang="scss" scoped></style>
